import * as React from "react";
const SvgBackFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M16.639 5.774A2 2 0 0 1 17 6.92v10.158a2 2 0 0 1-3.147 1.639L7 13.92V18a1 1 0 1 1-2 0V6a1 1 0 1 1 2 0v4.079l6.853-4.797a2 2 0 0 1 2.786.492", clipRule: "evenodd" }));
export default SvgBackFill;
